import { render } from "./DonationSums.vue?vue&type=template&id=4072d42c&scoped=true"
import script from "./DonationSums.vue?vue&type=script&lang=js"
export * from "./DonationSums.vue?vue&type=script&lang=js"

import "./DonationSums.vue?vue&type=style&index=0&id=4072d42c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./DonationSums.vue?vue&type=custom&index=0&blockType=span"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4072d42c"]])

export default __exports__